import VylorLogo from "components/VylorLogo";
import "./LoadingSpinner.css";

interface LoadingSpinnerProps {
  message?: string;
}

export default function LoadingSpinner(props: LoadingSpinnerProps) {
  const message = props.message ?? "Loading...";
  return (
    <div className="flex justify-center items-center vh-100 flex-column">
      <VylorLogo alt={message} id="loading-spinner" />
      <p className="f3 lh-copy helvetica">{message}</p>
    </div>
  );
}
